import { createContext } from "react";

const AlertDialogContext = createContext(null);

export default AlertDialogContext;
